import styled from 'styled-components'
import { media } from 'styles/media'

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > *:not(:only-child) {
    margin: 10px 0;
  }

  ${media.md`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  > *:not(:only-child) {
    margin: 0 10px;
  }
`}
`
